import { render, staticRenderFns } from "./VesselsResourcesCertTable.vue?vue&type=template&id=479debe9&"
import script from "./VesselsResourcesCertTable.vue?vue&type=script&lang=js&"
export * from "./VesselsResourcesCertTable.vue?vue&type=script&lang=js&"
import style0 from "./VesselsResourcesCertTable.vue?vue&type=style&index=0&id=479debe9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports